
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVoyages as ObiVoyagesElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-voyages.js';
 
 
 

 
 export const ObiVoyages = createComponent({
   react: React,
   tagName: 'obi-voyages',
   elementClass: ObiVoyagesElement,
   events: {
     
   }
  });
 
 